import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './event-list.component.scss';
var EventList = /** @class */ (function (_super) {
    tslib_1.__extends(EventList, _super);
    function EventList(element) {
        return _super.call(this, element) || this;
    }
    EventList.prototype.init = function () {
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        switch (this.sliderItems) {
            case 1:
                this.breakpoints = {};
                break;
            case 2:
                this.breakpoints = {
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    }
                };
                break;
            default:
                this.breakpoints = {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    }
                };
                break;
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    EventList.prototype.bindEvents = function () { };
    return EventList;
}(Base));
export { EventList };



//////////////////
// WEBPACK FOOTER
// ./components/event-list/event-list.component.ts
// module id = 269
// module chunks = 0